
import { Component, Prop, Vue } from "vue-property-decorator";
import { ISMSForm } from "@/models/SMS";
import { TInputRule } from "@nationbetter/nb-components/src/models/Input";
import { validateDate } from "@/utils/dates";

@Component
export default class StepZeroSMS extends Vue {
  @Prop({ type: Object, required: true }) readonly form!: ISMSForm;

  options = [
    {
      value: "Change to org.size/charitable status",
      label: "Change to org.size/charitable status",
    },
    { value: "Merger", label: "Merger" },
    { value: "De-merger", label: "De-merger" },
    { value: "Take-over", label: "Take-over" },
    { value: "Acquisition", label: "Acquisition" },
    { value: "Sale of business", label: "Sale of business" },
    { value: "Appoint a representative", label: "Appoint a representative" },
    { value: "Remove a representative", label: "Remove a representative" },
    { value: "Amend a represenative", label: "Amend a represenative" },
    { value: "Add a branch", label: "Add a branch" },
    { value: "Remove a branch", label: "Remove a branch" },
    { value: "Add a site", label: "Add a site" },
    { value: "Remove a site", label: "Remove a site" },
    { value: "Digitech application", label: "Digitech application" },
    { value: "Change to registration status/body", label: "Change to registration status/body" },
    { value: "Change to accreditation status/body", label: "Change to accreditation status/body" },
    { value: "Change to inspection status/body", label: "Change to inspection status/body" },
    { value: "Surrender a licence/tier/category", label: "Surrender a licence/tier/category" },
    { value: "Make licence dormant", label: "Make licence dormant" },
    { value: "Other", label: "Other" },
  ];

  setStep(step: number) {
    this.$emit("setStep", step);
  }

  dateRules: TInputRule[] = [(v) => validateDate(v) || "Not Allowed Format"];

  get isFormValid() {
    const {
      number_of_employees,
      number_of_employees_change_date,
      number_of_employees_change_reason,
      number_of_employees_change_details,
    } = this.form;
    if (!number_of_employees) return false;
    if (!validateDate(number_of_employees_change_date)) return false;
    if (!number_of_employees_change_reason) return false;
    if (!number_of_employees_change_details) return false;
    return true;
  }
}
